/**
 * Avatar mask for 16px badge
 */
export const avatarMask16 =
  'radial-gradient(circle 10.5px at calc(100% - 5.5px) calc(100% - 5.5px), #fff0 96%, #fff) 100% 100% / 100% 100% no-repeat';

/**
 * Avatar mask for 12px badge
 */
export const avatarMask12 =
  'radial-gradient(circle 8.5px at calc(100% - 3.5px) calc(100% - 3.5px), #fff0 96%, #fff) 100% 100% / 100% 100% no-repeat';
